module.exports = __webpack_public_path__ + "static/media/steak.1a69ca28.svg";